import { PAYMENT_STRATEGIES } from "../strategies/paymentStrategies";

export async function initializeCheckout({ billingType, purchaseId }) {
  const strategy = PAYMENT_STRATEGIES[billingType];

  if (!strategy) {
    throw new Error("Unsupported payment strategy.");
  }

  const response = await strategy.initializeIntent({
    purchaseId,
  });

  if (!response.ok) {
    throw new Error("Failed to initialize checkout intent.");
  }

  const data = await response.json();

  return {
    clientSecret: data.clientSecret,
    gatewayStatus: data.status,
  };
}
